"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Brush(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M19.483 2a2.575 2.575 0 0 1 1.699.686c.187.177.3.417.314.672.519.913.607 2.03-.097 2.871l-.006.006-7.994 9.389a1 1 0 0 1-.053.058c-.38.38-.882.573-1.387.58a4.01 4.01 0 0 1-1.152 2.54c-.506.506-1.144.816-1.908 1.164-.765.347-1.636.679-2.465.972-1.658.587-3.156 1.018-3.156 1.018a1 1 0 0 1-1.235-1.252s.457-1.495 1.055-3.149c.299-.826.633-1.694.973-2.453.34-.759.632-1.382 1.091-1.883.703-.766 1.633-1.13 2.583-1.168a1.986 1.986 0 0 1 .576-1.388 1 1 0 0 1 .058-.053l9.373-8a2.573 2.573 0 0 1 1.73-.61zM7.979 14.03c-.506-.014-.995.163-1.342.541-.09.1-.435.663-.742 1.348a35.23 35.23 0 0 0-1.122 2.91l-.068.211-.128.396c.5-.16.567-.164 1.189-.385a30.07 30.07 0 0 0 2.305-.908c.679-.308 1.228-.662 1.322-.756.827-.826.808-2.043.031-2.755a2.253 2.253 0 0 0-1.445-.602zm3.129-3.121l-1.37 1.17 2.188 2.187 1.168-1.37-1.986-1.987zm8.328-6.918a.572.572 0 0 0-.387.14l-6.414 5.477 1.76 1.76 5.47-6.424a.566.566 0 0 0-.048-.793.58.58 0 0 0-.381-.16z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Brush;
